<img _ngcontent-pge-c105="" src="../../assets/images/myvista-logo-white.png" alt="logo" class="hoverLogo" *ngIf="this.isEmbed === false">

<div class="iwg-form-dialog" [ngClass]="{'iwg-dialog-half-size': (selectedStepIndex == 1)}">
    <div class="md-toolbar-tools d-flex md-theme m-0 p-3">
        <h2 class="m-0 toolbartitle">
            {{WizardTitle}}
        </h2>
        <span class="flex"></span>
        <span *ngIf="selectedStepIndex < 1">Step {{selectedStepIndex + 1}} of {{numberOfSteps}}</span>
        <span *ngIf="selectedStepIndex >= 1">Review & Submit</span>
    </div>
    <mat-dialog-content>
        <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
        <div class="vista-popup-height">
            <div class="d-flex layout-row" style="height: 100%;">


                <div class="d-flex layout-column flex md-padding w-100"
                    style="height:100%;overflow-y: scroll;box-sizing: border-box;padding: 16px 0px 16px 16px">
                    <mat-tab-group [(selectedIndex)]="selectedStepIndex" class="header-less-tabs">
                        <mat-tab label="Step 1">
                            <form name="documentStep1" #documentStep1="ngForm">
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Document Type</mat-label>
                                       
                                        <input class="p-input" matInput name="documentTypeName" id="documentTypeName" [(ngModel)]="documentTypeName"
                                            #Ctitle="ngModel" maxlength="200" [disabled]="true">
                                    </mat-form-field>
                                    <mat-icon class="md-iwgNavbar-theme" matTooltip="Type of Document to be uploaded." matTooltipPosition="above" style="    text-transform: none !important;">
                                        help
                                    </mat-icon>
                                 
                                </div>
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip" appearance="none">
                                        <mat-label>Document Name</mat-label>
                                        <input matInput name="document_name" [(ngModel)]="step1.document_name" maxlength="200"
                                            required>
                                    </mat-form-field>
                                    <mat-icon class="md-iwgNavbar-theme" matTooltip="Name of the Document." matTooltipPosition="above">
                                        help
                                    </mat-icon>
                                   
                                </div>
                               <div class="md-input-container">
                                    <mat-datepicker-toggle flex fxFlex="11" fxLayoutAlign="space-between center"
                                        matSuffix [for]="picker">
                                    </mat-datepicker-toggle>
                                    <mat-form-field appearance="none" color="accent" flex fxFlex="35"
                                        class="mat-form-withtooltip" floatLabel="always">
                                        <mat-label>Issued Date</mat-label>
                                        <input matInput autofocus  [matDatepicker]="picker" name="start_date" #start_date="ngModel"
                                            placeholder="Select" [(ngModel)]="step1.issued_date" >
                                        <mat-datepicker-toggle matSuffix [for]="picker">
                                            <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                   
                                </div>
                                <div class="md-input-container">
                                    <mat-datepicker-toggle flex fxFlex="11" fxLayoutAlign="space-between center"
                                        matSuffix [for]="edpicker">
                                    </mat-datepicker-toggle>
                                    <mat-form-field appearance="none" color="accent" flex fxFlex="35"
                                        class="mat-form-withtooltip" floatLabel="always">
                                        <mat-label>Expiration Date</mat-label>
                                        <input matInput [matDatepicker]="edpicker" name="expiration"
                                            #expiration="ngModel" placeholder="Select" [(ngModel)]="step1.expiration_date" [min] = "step1.issued_date" autofocus >
                                        <mat-datepicker-toggle matSuffix [for]="edpicker">
                                            <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #edpicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <app-multiple-file-upload upload-url="/Api/Documents/UploadFile"
                                    [file-property]="'document_attachment_file'" [uploaded-file-name]="documentFileList" (create)="create($event)"
                                    ></app-multiple-file-upload>
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Notes</mat-label>
                                        <textarea matInput name="notes" [(ngModel)]="step1.notes" maxlength="200"
                                        rows="3" class="mat-textareafield"></textarea>
                                    </mat-form-field>
                                    <mat-icon class="md-iwgNavbar-theme" matTooltip="A complete description for the document."
                                        matTooltipPosition="above">
                                        help
                                    </mat-icon>
                                  
                                </div>
                            </form>
                        </mat-tab>
                        <mat-tab label="review">
                            <h3 class="font-weight-bold padt-30" style="padding-left: 10px;">Review Document Details</h3>
                            <div>
                                <div class="iwg-review-bar" layout="row" layout-align="start center"
                                    style="padding-left: 10px;margin-right: 21px;">
                                    <span class="iwg-review-bar-title">Step 1: Add a Document</span><span flex></span><a 
                                        (click)="selectedStepIndex=0" class="iwg-review-bar-edit" style="float: right;padding-right:5px">Edit</a>
                                </div>
                                <div class="padl-15">
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Contractor</label>
                                    <p class="iwg-regular-value">{{contractorName | blank}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Bussiness Name</label>
                                    <p class="iwg-regular-value">{{bussinessName | blank}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Document Type</label>
                                    <p class="iwg-regular-value">{{documentTypeName | blank}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Document Name</label>
                                    <p class="iwg-regular-value">{{step1.document_name}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Issued Date</label>
                                    <p class="iwg-regular-value">{{step1.issued_date | date}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Expiration Date</label>
                                    <p class="iwg-regular-value">{{step1.expiration_date | date}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Document File</label>
                                    <ng-container *ngIf="documentFileList && documentFileList.length!= 0">
                                        <div *ngFor="let fileDetail of documentFileList">
                                            <p class="iwg-regular-value" style="overflow-wrap: break-word;white-space: normal;">
                                                {{fileDetail?.Name | blank}}
                                                <button mat-button class="mat-icon-button" [disabled]="isLoading" (click)="downloadDocumentFile(fileDetail.ID)">
                                                    <mat-icon class="icon_color">file_download</mat-icon>
                                </button>
                                            </p>
                                        </div>
                                    </ng-container>
                                </div>
                              
                                <div class="iwg-widget-box-card" style="padding-top: 0px !important;">
                                    <label class="iwg-regular-label">Notes</label>
                                    <p class="iwg-regular-value">{{step1.notes | blank}}</p>
                                </div>
                            </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
                <div class="d-flex layout-column flex md-padding w-100" style="overflow: auto;" *ngIf="selectedStepIndex == 0">
                <div class="iwg-widget-box-card">
                    <label class="iwg-regular-label">Contractor</label>
                    <p class="iwg-regular-value">{{contractorName | blank}}</p>
                </div>
                <div class="iwg-widget-box-card">
                    <label class="iwg-regular-label">Bussiness Name</label>
                    <p class="iwg-regular-value">{{bussinessName | blank}}</p>
                </div>
                <div class="iwg-widget-box-card">
                    <label class="iwg-regular-label">Document Type</label>
                    <p class="iwg-regular-value">{{documentTypeName | blank}}</p>
                </div>
                <div class="iwg-widget-box-card">
                    <label class="iwg-regular-label">Document Name</label>
                    <p class="iwg-regular-value">{{step1.document_name | blank}}</p>
                </div>
                <div class="iwg-widget-box-card">
                    <label class="iwg-regular-label">Issued Date</label>
                    <p class="iwg-regular-value">{{step1.issued_date | date}}</p>
                </div>
                <div class="iwg-widget-box-card">
                    <label class="iwg-regular-label">Expiration Date</label>
                    <p class="iwg-regular-value">{{step1.expiration_date | date}}</p>
                </div>
                <div class="iwg-widget-box-card">
                    <label class="iwg-regular-label">Document File</label>
                    <div *ngFor="let fileDetail of documentFileList">
                        <p class="iwg-regular-value" style="width:100%; overflow-wrap: break-word;white-space: normal;align-items: center;">
                            {{fileDetail?.Name | blank}}
                            <button mat-button class="mat-icon-button" [disabled]="isLoading" (click)="downloadDocumentFile(fileDetail.ID)">
                                                <mat-icon class="icon_color">file_download</mat-icon>
                            </button>
                            <button mat-button class="mat-icon-button" [disabled]="isLoading" (click)="deleteDocumentFile(fileDetail.ID)">
                                <mat-icon class="icon_color">delete</mat-icon>
                            </button>
                        </p>
                    </div>
                </div>
                <div class="iwg-widget-box-card" style="padding-top: 0px !important;">
                    <label class="iwg-regular-label">Notes</label>
                    <p class="iwg-regular-value">{{step1.notes | blank}}</p>
                </div>
                </div>
            </div>

        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="justify-fend">
        <div fxLayout="row" fxLayoutAlign="space-between center" style="overflow:auto;"
            [ngClass]="{'mobile-space-btn': (selectedStepIndex != 1)}">
            <div class="vista-action-btnback" *ngIf="selectedStepIndex != 0">
                <button class="back-btn-vista" mat-button (click)="prevStep()" *ngIf="selectedStepIndex != 0">
                    « Back
                </button>
            </div>
            <span flex></span>
            <button mat-button (click)="cancel()" [disabled]="isFileUploadInProgress" *ngIf="selectedStepIndex != 1">
                Cancel
            </button>
           
            <button mat-button class="vista-dialogbtn" *ngIf="selectedStepIndex != 1" 
                (click)="nextStep()" [disabled]="!canProceed() || isFileUploadInProgress">Save & Continue</button>
            <button mat-button (click)="saveAsDraft()" *ngIf="selectedStepIndex != 0">
                Save as Draft
            </button>
            <button mat-button class="vista-dialogbtn" (click)="submit()"
                *ngIf="selectedStepIndex != 0">
                Submit
            </button>
            
        </div>
    </mat-dialog-actions>
</div>